import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ToastProvider } from '../../providers/toast/toast';
import { LoginProvider } from '../../providers/login/login';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-forgot-pass',
  templateUrl: 'forgot-pass.html',
})
export class ForgotPassPage {

  oldPass: string = "";
  newPass: string = "";
  confirmPass: string = "";

  constructor(public navCtrl: NavController, 
	  public navParams: NavParams, 
	  private translate: TranslateService,
  	private toast: ToastProvider, 
  	private loginProvider: LoginProvider) {

  }

  onChangePass(){
  	if(this.newPass != this.confirmPass){
  		this.toast.presentToast("Password doesn't match");
  	}else{
  		this.loginProvider.changePass({
  			cpassword: this.confirmPass,
  			new_password: this.newPass,
  			old_password: this.oldPass
  		}).then(val => {
  			if(val.status == "success"){
  				this.toast.presentToast(val.message)
  				this.navCtrl.pop();
  			}else{
  				this.toast.presentToast(val.message)
  			}
  		});
  	}
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ForgotPassPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/forgot-pass/forgot-pass.ts